import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import React from "react";
import type { VectorEmbeddingModel } from "../../types/vector";

export interface DeleteNamespaceDialogProps {
  embeddingModelName: VectorEmbeddingModel;
  open: boolean;
  name: string;
  id: string;
  onOpenChange: (open: boolean) => void;
  onNamespaceDelete: (args: {
    embeddingModelName: VectorEmbeddingModel;
    namespaceId: string;
    namespaceName: string;
    spaceId?: string;
  }) => void;
}

export const DeleteNamespaceDialog: React.FC<DeleteNamespaceDialogProps> = ({
  embeddingModelName,
  name,
  id,
  open,
  onOpenChange,
  onNamespaceDelete,
}) => (
  <Dialog
    open={open}
    onClose={() => onOpenChange(false)}
    aria-labelledby="namespace-alert-dialog-title"
    aria-describedby="namespace-alert-dialog-description"
  >
    <DialogTitle fontSize="1.25rem" id="namespace-alert-dialog-title">
      Delete namespace
    </DialogTitle>

    <DialogContent>
      <DialogContentText
        id="namespace-alert-dialog-description"
        sx={{ lineHeight: "140%" }}
      >
        Are you sure you want to delete the namespace:{" "}
        <span style={{ fontWeight: 800 }}>&quot;{name}&quot;</span>. You will
        not be able to restore after it is deleted.
      </DialogContentText>
    </DialogContent>

    <DialogActions>
      <Button variant="text" onClick={() => onOpenChange(false)}>
        Cancel
      </Button>

      <Button
        variant="contained"
        onClick={() => {
          onOpenChange(false);
          onNamespaceDelete({
            embeddingModelName,
            namespaceId: id,
            namespaceName: name,
          });
        }}
      >
        Delete
      </Button>
    </DialogActions>
  </Dialog>
);
